import { IAPIAction } from "us.collection/interfaces";
import { FileConverter } from "../../constants/Actions";
import { IFileConverterAction } from "us.collection.input-output/interfaces";

export const fileConverter: Readonly<IAPIAction & IFileConverterAction> = {
  preview: {
    save: (data) => ({
      type: FileConverter.PREVIEW_FILE_START,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: FileConverter.PREVIEW_FILE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: FileConverter.PREVIEW_FILE_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    updateFiles: (data) => ({
      type: FileConverter.UPDATE_FILE_LIST,
      payload: {
        data,
        isLoading: true,
      },
    }),
    reset: (data) => ({
      type: FileConverter.RESET_FILE_IMPORT,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  importFiles: {
    save: (data) => ({
      type: FileConverter.IMPORT_FILE_START,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: FileConverter.IMPORT_FILE_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: FileConverter.IMPORT_FILE_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  mappingProfiles: {
    get: (data) => ({
      type: FileConverter.GET_MAPPING_PROFILES_START,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: FileConverter.GET_MAPPING_PROFILES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: FileConverter.GET_MAPPING_PROFILES_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
